import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/auth/Login';
// Main pages
import { Dashboard, Parties, SalesOrders, PurchaseOrders, Containers, Invoices, PurchaseBills, GRN, Products, OrderTrail, Receivables, Payables } from './pages/index';
// Extra pages
import { Alerts, ShippingBills, Documents, Customs, GST, DGFT, EwayBills, MIS, Settings } from './pages/extra';
// Accounts pages
import { AccountsDashboard, ChartOfAccounts, JournalVouchers, Ledger, TrialBalance, ProfitLoss, BalanceSheet, CashFlow, DayBook, TDS } from './pages/accounts';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="text-center"><div className="text-4xl mb-4">⚓</div><div className="w-8 h-8 border-4 border-amber-400 border-t-transparent rounded-full animate-spin mx-auto"></div><p className="text-slate-400 text-sm mt-3">Loading TradeFlow ERP...</p></div>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/*" element={
        <PrivateRoute>
          <Layout>
            <Routes>
              <Route path="/"                    element={<Dashboard />} />
              <Route path="/alerts"              element={<Alerts />} />
              <Route path="/parties"             element={<Parties />} />
              <Route path="/sales-orders"        element={<SalesOrders />} />
              <Route path="/invoices"            element={<Invoices />} />
              <Route path="/purchase-orders"     element={<PurchaseOrders />} />
              <Route path="/grn"                 element={<GRN />} />
              <Route path="/bills"               element={<PurchaseBills />} />
              <Route path="/containers"          element={<Containers />} />
              <Route path="/shipping-bills"      element={<ShippingBills />} />
              <Route path="/documents"           element={<Documents />} />
              <Route path="/customs"             element={<Customs />} />
              <Route path="/gst"                 element={<GST />} />
              <Route path="/dgft"                element={<DGFT />} />
              <Route path="/eway-bills"          element={<EwayBills />} />
              <Route path="/order-trail"         element={<OrderTrail />} />
              <Route path="/receivables"         element={<Receivables />} />
              <Route path="/payables"            element={<Payables />} />
              <Route path="/mis"                 element={<MIS />} />
              <Route path="/products"            element={<Products />} />
              <Route path="/settings"            element={<Settings />} />
              {/* ── ACCOUNTS MODULE ── */}
              <Route path="/accounts"            element={<AccountsDashboard />} />
              <Route path="/accounts/chart"      element={<ChartOfAccounts />} />
              <Route path="/accounts/vouchers"   element={<JournalVouchers />} />
              <Route path="/accounts/ledger"     element={<Ledger />} />
              <Route path="/accounts/trial-balance" element={<TrialBalance />} />
              <Route path="/accounts/profit-loss"   element={<ProfitLoss />} />
              <Route path="/accounts/balance-sheet" element={<BalanceSheet />} />
              <Route path="/accounts/cash-flow"     element={<CashFlow />} />
              <Route path="/accounts/day-book"      element={<DayBook />} />
              <Route path="/accounts/tds"           element={<TDS />} />
              <Route path="*"                    element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </PrivateRoute>
      } />
    </Routes>
  );
}
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ duration:3500, style:{ fontSize:'0.85rem', fontFamily:'Outfit,sans-serif', borderRadius:'10px' } }} />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
